import React from 'react'

const Journey = () => {
  return (
    <div>
        
<div className=' relative  font-semibold  bg-black md:bg-transparent text-white min-h-screen md:mb-4 mb-0 '>
<img src="https://wallpaperset.com/w/full/2/b/8/494749.jpg" alt="dofjdog" className="absolute w-full min-h-screen z-1 " width="1308" />
  <div className ='md:flex md:flex-row flex-col justify-start items-center z-10'>
    <div className='md:w-1/3 flex flex-col items-start justify-end mx-2 '>
    <h1 className='text-6xl md:-mt-32 mt-4 pt-12 bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-teal-500 font-black z-20'>Smart-Contracts</h1>
    
    </div>
      <div className='md:relative mt-24 flex flex-col p-3 bg-gradient-to-r from-red-200 via-red-300 to-yellow-200 items-center justify-start rounded-lg text-black m-8  md:w-1/3'
      data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1000" data-aos-easing="ease-in-sine">
        <h1 className ='text-4xl m-6'>DEFI Contracts</h1>
        <a href='https://github.com/Anmo1Sen/ERC-20_Dapp/blob/main/contracts/FunToken.sol'
        className="mt-4 mx-4">Ethers Transfer Contract </a>
        <a href='https://github.com/Anmo1Sen/ERC-20_Dapp/blob/main/contracts/FunToken.sol'
         className="mt-4 mx-4">ERC-20 Token. </a>
        <a href= "https://github.com/Anmo1Sen/AAve-flesh-loan"
        className="m-4">Aave Flesh Loan.</a>
        <a href='https://github.com/Anmo1Sen/Dao-Governance'
        className="mt-4 mx-4">DAO-Simple Smart Contract.</a>
        <a href='https://github.com/Anmo1Sen/stakingContract'
        className="m-4">Staking Tokens</a>
       
      </div>

       <div className=' md:absolute md:bottom-2 right-2 z-20  flex flex-col p-3 bg-gradient-to-r from-yellow-600 to-red-600 items-center justify-start rounded-lg text-black m-8 mb-0  md:w-1/3'
       data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1800" data-aos-easing="ease-in-sine">
        <h1 className ='text-4xl m-3'>NFT Smart-Contracts</h1>
        <a href='https://github.com/Anmo1Sen/NFT/tree/master'
         className="mt-4 mx-4">ERC-721 Contract </a >
        <a  href='https://github.com/Anmo1Sen/Dynamic_OnChainNFT'
        className="mt-4 mx-4">On-chain Dynamic NFT Contract</a >
        <a href='https://github.com/Anmo1Sen/AirdropNFT'
         className="mt-4 mx-4">On-Chain  and Off-Chain NFT Allowlist Contract</a >
        <a  href='https://github.com/Anmo1Sen/AirdropNFT'
        className="m-4">AirDrop NFTs</a >
        <a  href='https://github.com/Anmo1Sen/NFTmarketPlace'
        className="m-4">NFT MarketPlace</a >
        
      </div>

  </div>
</div>
    </div>
  )
}


export default Journey